export const CHANGE_ACTIVITY_REASSIGN_REQUEST = 'CHANGE_ACTIVITY_REASSIGN_REQUEST';
export const CHANGE_ACTIVITY_REASSIGN_SUCCESS = 'CHANGE_ACTIVITY_REASSIGN_SUCCESS';
export const CHANGE_ACTIVITY_REASSIGN_ERROR = 'CHANGE_ACTIVITY_REASSIGN_ERROR';
export const GET_REASSIGN_ACTIVITY_REQUEST = 'GET_REASSIGN_ACTIVITY_REQUEST';
export const GET_REASSIGN_ACTIVITY_REQUEST_SUCCESS = 'GET_REASSIGN_ACTIVITY_REQUEST_SUCCESS';
